// Centralized constants for NO BS, only GS

export const APP_NAME = "DISTILL";
export const APP_TAGLINE = "No BS, only GS.";
export const APP_SUBLINE = "The distilled news brief for aspirants.";

// Site owner (single-admin app). Only this email — when authenticated via
// Google Sign-In — can see the Settings > Admin section and open /studio.
// Kept in-code (not env var) so the frontend bundle doesn't need to redeploy
// on backend env changes; keep in sync with backend `OWNER_EMAIL`.
export const OWNER_EMAIL = "distillgs@gmail.com";

export function isOwner(user) {
  return !!user && (user.email || "").trim().toLowerCase() === OWNER_EMAIL;
}

export const CATEGORIES = [
  { key: "all", label: "All Feed" },
  { key: "prelims", label: "Prelims" },
  { key: "gs", label: "GS 1-3" },
  { key: "pib", label: "PIB Filtered" },
  { key: "data", label: "Data" },
  { key: "ethics_essay", label: "Ethics & Essay" },
];

export const CARD_CATEGORY_LABELS = {
  "GS-1": "GS-1: Society",
  "GS-2": "GS-2: Polity",
  "GS-3": "GS-3: Economy",
  "GS-4": "GS-4: Ethics",
  "Prelims": "Prelims",
  "PIB": "PIB Filtered",
  "Ethics": "GS-4: Ethics",
};

export const QUIZ_EVERY_N = 7; // insert quiz roughly every 7 cards

export const TID = {
  splashRoot: "splash-root",
  splashTitle: "splash-title",
  splashTagline: "splash-tagline",

  pledgeAccept: "pledge-accept-button",
  pledgeDismiss: "pledge-dismiss-button",
  pledgeOpen: "settings-view-pledge-button",

  feedContainer: "feed-container",
  feedFilterPill: "feed-filter-pill",
  feedFilterPillActive: "feed-filter-pill-active",

  cardRoot: "news-card-root",
  cardHeadline: "news-card-headline",
  cardSummary: "news-card-summary",
  cardCategoryBadge: "card-category-badge",
  cardBookmark: "card-bookmark-button",
  cardFlip: "card-flip-button",
  cardFlipBack: "card-flip-back-button",
  cardPyq: "card-pyq-badge",

  quizRoot: "feed-quiz-card",
  quizSubmit: "quiz-submit-button",
  quizOption: "quiz-option",

  bottomTab: "bottom-tab",
  bottomTabActive: "bottom-tab-active",
  gazetteDot: "gazette-unread-indicator",

  searchInput: "search-input",
  searchTrendingChip: "search-trending-chip",
  searchResult: "search-result-item",

  savedPurgeIndicator: "saved-auto-purge-indicator",
  savedItem: "saved-card-item",
  savedEmptyGoFeed: "saved-empty-go-feed",

  gazettePost: "gazette-post",
  gazettePostTitle: "gazette-post-title",

  zhBucketKeep: "zero-hour-bucket-keep",
  zhBucketTrash: "zero-hour-bucket-trash",
  zhBucketBuild: "zero-hour-bucket-build",
  zhFeedbackText: "zero-hour-feedback-text",
  zhSubmit: "zero-hour-submit-button",

  settingsDigestToggle: "settings-silent-digest-toggle",

  adminEmail: "admin-login-email",
  adminPassword: "admin-login-password",
  adminSubmit: "admin-login-submit",
  adminNewCard: "admin-new-card-button",
  adminNewGazette: "admin-new-gazette-button",
  adminRow: "admin-item-row",
  adminEdit: "admin-item-edit",
  adminDelete: "admin-item-delete",
  adminSave: "admin-editor-save-button",
  adminWordCounter: "admin-summary-word-counter",

  signInPromptRoot: "signin-prompt",
  signInPromptContinue: "signin-prompt-continue",
  signInPromptDismiss: "signin-prompt-dismiss",
};
